import { sanitizeHtml } from '@/components/Functional/utils/sanitizeHtml'
import { Button } from '@/components/UI/Button'
import { Dialog } from '@/components/UI/Dialog'
import { IconLogin } from '@tabler/icons-react'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  /** ダイアログが開いているか */
  opened: boolean
  /** 閉じる時のコールバック */
  onClose: () => void
  /** ログイン・会員登録画面のURL（useCampaignSlug().loginUrl） */
  loginUrl: string
  /** モーダルが開いている間、bodyのスクロールをロックするか。Storybookなど埋め込み環境では false にする（default: true） */
  scrollLock?: boolean
}

/**
 * 非ログイン時に会員登録・ログインへ誘導するダイアログ。
 * スタンプ獲得など、認証が必要な操作をした際に表示する。
 */
export const DialogLoginRequired = memo(({ opened, onClose, loginUrl, scrollLock = true }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog selectorState={opened} compact showCloseButton={false} lockScroll={scrollLock} closeAction={onClose}>
      <div className="flex flex-col items-center gap-[8px] mt-2">
        <div className="flex items-center justify-center w-[64px] h-[64px] rounded-full bg-[#f5f5f5] mb-[8px]">
          <IconLogin size={32} className="text-[#757575]" />
        </div>

        <p className="text-center text-[16px] font-bold text-black leading-[22px] mb-[8px]">
          {t('dialog_login_required.title', 'ログイン後に取得可能です')}
        </p>

        {/* 翻訳値に <br> を含むため HTML として描画する */}
        <p
          className="text-center text-[14px] text-gray-500 leading-[18px] mb-[8px]"
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              t('dialog_login_required.description', '会員登録・ログインすると<br>スタンプを獲得できます'),
            ),
          }}
        />
        <Button
          label={t('dialog_login_required.login_button', '会員登録・ログイン')}
          variant="primary"
          size="md"
          href={loginUrl}
          fullWidth
        />
        <Button label={t('common.cancel', 'キャンセル')} variant="system-back" size="md" onClick={onClose} fullWidth />
      </div>
    </Dialog>
  )
})
